export const LProdIndicador = [
  { key: '0', value: "INDCOM0", text: "0 - Não pagar comissão" },
  { key: '1', value: "INDCOM1", text: "1 - Usar fator de acréscimo/decréscimo" },
];
